import { isAllowedEmailDomain, isEmail, isImageFile, isKana, isNumber, isValidFormatPassword, isRequired, isRequiredText, strMax, strMin, } from './utils';
export const validateLoginId = [
    isRequiredText('ログインIDを入力してください'),
    strMax(20, 'ログインIDは20文字以内で入力してください'),
];
/**
 * @deprecated TS化済 src/utils/validate/common.ts
 */
export const validateLastName = [
    isRequiredText('姓を入力してください'),
    strMax(20, '姓は20文字以内で入力してください'),
];
export const validateNullableLastName = [
    strMax(20, '姓は20文字以内で入力してください'),
];
/**
 * @@deprecated TS化済 src/utils/validate/common.ts
 */
export const validateFirstName = [
    isRequiredText('名を入力してください'),
    strMax(20, '名は20文字以内で入力してください'),
];
export const validateNullableFirstName = [
    strMax(20, '名は20文字以内で入力してください'),
];
export const validateLastNameKana = [
    isRequiredText('姓(カナ)を入力してください'),
    isKana('カタカナで入力してください'),
    strMax(20, '姓(カナ)は20文字以内で入力してください'),
];
export const validateFirstNameKana = [
    isRequiredText('名(カナ)を入力してください'),
    isKana('カタカナで入力してください'),
    strMax(20, '名(カナ)は20文字以内で入力してください'),
];
export const validateCompanyName = [
    isRequiredText('会社名を入力してください'),
    strMax(50, '会社名は50文字以内で入力してください'),
];
export const validateAddress = [
    isRequiredText('住所を入力してください'),
    strMax(255, '住所は255文字以内で入力してください'),
];
export const validateOther = [strMax(255, '255文字以内で入力してください')];
export const validateOtherRequired = [
    isRequiredText('その他を入力してください'),
    strMax(255, '255文字以内で入力してください'),
];
export const validateOtherRequiredWith = [
    isRequiredText('その他の項目を選択した場合は詳細を記入してください'),
    strMax(255, '255文字以内で入力してください'),
];
export const validateOtherSmallRequired = [
    isRequiredText('その他を入力してください'),
    strMax(25, '25文字以内で入力してください'),
];
export const validateOther10SmallRequired = [
    isRequiredText('その他を入力してください'),
    strMax(10, '10文字以内で入力してください'),
];
export const validateEmail = [
    isRequiredText('メールアドレスを入力してください'),
    // strMax(255, 'メールアドレスは255文字以内で入力してください'),
    // 文字数制限はisEmail関数の中で行われているのでチェックしない
    isEmail('メールアドレス形式が正しくありません'),
    isAllowedEmailDomain('フリーメールアドレスは使用できません'),
];
/**
 * @deprecated TS化済 src/utils/validate/common.ts
 */
export const validateEmailAllowFree = [
    isRequiredText('メールアドレスを入力してください'),
    // strMax(255, 'メールアドレスは255文字以内で入力してください'),
    // 文字数制限はisEmail関数の中で行われているのでチェックしない
    isEmail('メールアドレス形式が正しくありません'),
];
export const validatePasswordInputNoRequired = [
    strMax(50, 'パスワードは50文字以内で入力してください'),
    strMin(8, 'パスワードは8桁以上で入力してください'),
    isValidFormatPassword('パスワードには半角英字、半角数字、半角記号を少なくともそれぞれ1文字ずつ含めてください。また、先頭・末尾にスペースは使用できません'),
];
export const validatePasswordLogin = [
    isRequiredText('パスワードを入力してください'),
    strMax(50, 'パスワードは50文字以内で入力してください'),
];
export const validateNumber = [
    isRequiredText('数値を入力してください'),
    strMax(99, '桁が多すぎます。入力内容をご確認ください'),
    isNumber('半角数字で入力してください'),
];
export const validateSelected = [isRequired];
export const validateImageFile = [
    isImageFile('jpg, またはpngの形式の画像ファイルを選択してください'),
];
